/**
 * Product Gallery - Flickity init for Product__Slideshow and Product__SlideshowNav--thumbnails
 * 1:1 with OLD theme product page gallery behavior
 */
(function() {
  var FLICKITY_CDN = 'https://unpkg.com/flickity@2.3.0/dist/flickity.pkgd.min.js';
  var INIT_KEY = 'data-product-gallery-init';

  function initProductGallery() {
    var section = document.querySelector('[data-section-type="product"]');
    if (!section || section.getAttribute(INIT_KEY) === 'true') return;

    var mainSlideshow = section && section.querySelector('.Product__Slideshow--zoomable, .Product__Slideshow');
    var thumbSlideshow = section && section.querySelector('.Product__SlideshowNav--thumbnails');
    var initialIndex = parseInt(section.getAttribute('data-initial-image-index') || '0', 10);

    function doInit() {
      if (window.Flickity && mainSlideshow && !mainSlideshow.flickity) {
        section.setAttribute(INIT_KEY, 'true');
        try {
          new Flickity(mainSlideshow, {
            prevNextButtons: true,
            pageDots: true,
            adaptiveHeight: true,
            watchCSS: false,
            dragThreshold: 8,
            initialIndex: initialIndex,
            arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 }
          });
        } catch (e) {}
      }
      if (window.Flickity && thumbSlideshow && !thumbSlideshow.flickity) {
        try {
          new Flickity(thumbSlideshow, {
            asNavFor: mainSlideshow,
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            draggable: true,
            wrapAround: true
          });
        } catch (e) {}
      }
    }

    if (window.Flickity) {
      doInit();
      return;
    }

    var s = document.createElement('script');
    s.src = FLICKITY_CDN;
    s.async = true;
    s.onload = doInit;
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = (e.target.querySelector && e.target.querySelector('[data-section-type="product"]')) || (e.target.getAttribute && e.target.getAttribute('data-section-type') === 'product' ? e.target : null);
    if (section) section.removeAttribute(INIT_KEY);
    initProductGallery();
  });
})();
